import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IEmailBodyTemplateField {
	changeEmailBodyTemplate: (value: string) => void;
}

const EmailBodyTemplateField: React.FC<IEmailBodyTemplateField> = ({ changeEmailBodyTemplate }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterEmailBodyTemplate') }], [t]);

	return (
		<FormInput
			testId="EmailBodyTemplateField"
			name="emailBodyTemplate"
			label="emailBodyTemplateLabel"
			onChange={changeEmailBodyTemplate}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(EmailBodyTemplateField);
